// extracted by mini-css-extract-plugin
module.exports = {"builder":"tenantsBuilder_builder__1S2gK","links":"tenantsBuilder_links__3BLm8","active":"tenantsBuilder_active__3UV9x"};